export function mergeDefined<T extends Record<string, unknown>>(base: T, patch: Partial<T>): T {
  const defined = Object.fromEntries(
    Object.entries(patch as Record<string, unknown>).filter(([, v]) => v !== undefined),
  ) as Partial<T>
  return { ...base, ...defined }
}
